<template>
  <v-card class="pa-4" flat>
    <v-tabs v-model="tabs" grow>
      <v-tab>
        <v-icon right>mdi-format-list-numbered-rtl</v-icon>
        لیست
      </v-tab>
      <v-tab>
        <v-icon right>mdi-plus</v-icon>
        افزودن
      </v-tab>
    </v-tabs>
    <v-divider class="mt-0" />

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <vue-table :data="data" :headers="headers" @change="onPagination">
          <template v-slot:filters="{ props, perPage }">
            <v-row no-gutters>
              <v-col class="pa-2" cols="12" lg="1" md="2">
                <v-select
                  v-model="props.length"
                  :items="perPage"
                  class="rounded-lg"
                  dense
                  hide-details
                  label="تعداد"
                  outlined
                />
              </v-col>
              <v-col class="pa-2" cols="12" lg="4" md="6">
                <v-text-field
                  v-model="props.search"
                  append-icon="mdi-magnify"
                  class="rounded-lg"
                  clearable
                  dense
                  hide-details
                  label="جستجو"
                  outlined
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:index="{ item }">
            {{ item.index + 1 + (data.current_page - 1) * data.per_page }}
          </template>

          <template v-slot:type="{ item }">
            <span v-if="!!typeItems.find((t) => t.value === item.type)">
              {{ typeItems.find((t) => t.value === item.type).text }}
            </span>
          </template>

          <template v-slot:Enable="{ item }">
            <v-chip :color="item.Enable ? 'success' : 'red'" dark small>
              {{ item.Enable ? "فعال" : "غیرفعال" }}
            </v-chip>
          </template>

          <template v-slot:action="{ item }">
            <v-speed-dial
              v-model="fab"
              direction="right"
              transition="slide-x-transition"
            >
              <template v-slot:activator>
                <v-btn v-model="fab" icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-btn
                class="btn-delete rounded-pill"
                fab
                small
                @click="deleteRow(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-speed-dial>
          </template>
        </vue-table>
      </v-tab-item>

      <v-tab-item>
        <add-together-token @fetch="savedToken" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import AddTogetherToken from "@/view/pages/admin/tokens/addTogetherToken.vue";

export default {
  name: "togetherToken",

  components: { AddTogetherToken },

  data: () => ({
    headers: [
      { value: "index", text: "ردیف", sortable: false, align: "center" },
      { value: "id", text: "شناسه", sortable: false, align: "center" },
      { value: "email", text: "ایمیل", sortable: false, align: "center" },
      { value: "password", text: "پسوورد", sortable: false, align: "center" },
      {
        value: "req_left",
        text: "درخواست باقی‌مانده",
        sortable: false,
        align: "center",
      },
      { value: "type", text: "نوع", sortable: false, align: "center" },
      {
        value: "created_at_p",
        text: "زمان ساخت",
        sortable: false,
        align: "center",
      },
      {
        value: "updated_at_p",
        text: "زمان ویرایش",
        sortable: false,
        align: "center",
      },
      { value: "Enable", text: "وضعیت", sortable: false, align: "center" },
      { value: "action", text: "مدیریت", sortable: false, align: "center" },
    ],
    data: {},
    loading: false,
    tableProps: {
      page: 1,
      length: 10,
      dir: "desc",
      search: "",
    },
    fab: false,
    tabs: 0,
    typeItems: [
      { value: "togetherAi", text: "togetherAi - خلق تصویر" },
      { value: "openRouter", text: "openRouter - چت بات" },
    ],
  }),

  mounted() {
    this.fetch();
  },

  methods: {
    fetch(params = this.tableProps) {
      this.loading = true;

      this.$api
        .get("/v1/testQr/token", {
          params,
        })
        .then(({ data }) => (this.data = data.data))
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || "خطا در دریافت لیست توکن‌ها!",
          );
        })
        .finally(() => (this.loading = false));
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.fetch(props);
    },
    async deleteRow(item) {
      if (await this.$modal.yesNo("حذف توکن انتخاب شده؟!")) {
        this.loading = true;

        this.$api
          .delete(`/v1/testQr/delete/${item.id}`)
          .then(({ data }) => {
            this.$toast.success("با موفقیت حذف شد.");
            this.fetch();
          })
          .catch(({ response }) => {
            this.$toast.error(response?.data?.message || "خطا در حذف توکن!");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    savedToken() {
      this.tabs = 0;
      this.onPagination({ page: 1 });
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}
</style>
